import { Helmet } from "react-helmet-async";

type HeadProps = {
  title: string;
};

export const Head = ({ title }: HeadProps) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};
